<template>
  <b-modal id="editProfileModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.profile.editProfileHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Loader v-if="isLoading"></Loader>
        <EditProfileForm
                v-else-if="item"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EditProfileForm from './EditProfileForm'
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'

export default {
  name: 'EditProfileModal',
  components: {
    EditProfileForm,
    Loader
  },
  data () {
    return {
      item: {},
      routeName: ''
    }
  },
  computed: {
    show () {
      return this.$store.state.modals.profile.update.show
    },
    userdataObject () {
      return this.$store.state.modals.profile.update.userdataObject
    },
    close () {
      return this.$store.state.modals.profile.update.close
    },
    ...mapGetters({
      isLoading: 'userdata/update/isLoading',
      error: 'userdata/update/error',
      deleteError: 'userdata/del/error',
      deleteLoading: 'userdata/del/isLoading',
      created: 'userdata/create/created',
      deleted: 'userdata/del/deleted',
      retrieved: 'userdata/update/retrieved',
      updated: 'userdata/update/updated',
      violations: 'userdata/update/violations'
    })
  },
  created () {
    this.routeName = this.$route.name
  },
  watch: {
    show: function () {
      this.openModal()
    },
    userdataObject: function () {
      this.openModal()
    },
    close: function () {
      if (this.routeName === 'UserProfile' && this.close === 1) {
        this.$bvModal.hide('editProfileModal')
        this.$store.state.modals.profile.update.close = 0
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'UserDataList' })
    },
    updated: function () {
      this.$bvModal.hide('editProfileModal')
    }
  },
  methods: {
    ...mapActions({
      createReset: 'userdata/create/reset',
      deleteItem: 'userdata/del/del',
      delReset: 'userdata/del/reset',
      retrieve: 'userdata/update/retrieve',
      updateReset: 'userdata/update/reset',
      update: 'userdata/update/update',
      updateRetrieved: 'userdata/update/updateRetrieved'
    }),
    onSendForm () {
      let item = this.item
      if (item.idClientType) {
        item.idClientType = item.idClientType['@id']
      }
      if (item.users) {
        delete item.users
      }
      if (item.userDataFirms) {
        delete item.userDataFirms
      }
      if (item.idEmployer) {
        delete item.idEmployer
      }
      item.phoneMobileToSms = parseInt(item.phoneMobileToSms)
      this.$store.state.userdata.update.retrieved = item
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    },
    openModal () {
      if (this.show === 1 && Object.entries(this.userdataObject).length > 0) {
        this.item = JSON.parse(JSON.stringify(this.userdataObject))
        this.$store.state.modals.profile.update.show = 0
        this.$store.state.modals.profile.update.userdataObject = {}
        this.$bvModal.show('editProfileModal')
      }
    },
    resetData () {
      this.$store.state.userdata.update.retrieved = null
      this.$store.state.userdata.update.updated = null
      this.$store.state.userdata.update.violations = null
      this.$store.state.userdata.update.error = ''
    }
  }
}
</script>
